export enum TextAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
  Top = 'top',
  Middle = 'middle',
  Bottom = 'bottom'
}



// WEBPACK FOOTER //
// ./src/data/TextAlignment.ts